import * as React from 'react';
import {
  ProductSlugs,
  SupportedIntegrationProductSlugs
} from '../../../common/constants';
import { IntegrationLogo } from './IntegrationLogo';
import styles from './IntegrationIssueLink.css';
import { type UniversalIssue } from '@deque/axe-devtools-issues-utils';
import Link from '../../../common/components/Link';
import { getIntegrationProductInfoFromSlug } from '../../../common/utils/get-integration-product-name-from-slug';

const integrationContentMap = {
  [SupportedIntegrationProductSlugs.jiraIntegration]: {
    title: getIntegrationProductInfoFromSlug(ProductSlugs.jiraIntegration)
      .displayName,
    getIssueKeyByUrl: (url: string) => url.match(/(\/)(\w+-\d+)/)?.at(2)
  },
  [SupportedIntegrationProductSlugs.jiraDirectCloudIntegration]: {
    title: getIntegrationProductInfoFromSlug(
      ProductSlugs.jiraDirectCloudIntegration
    ).displayName,
    getIssueKeyByUrl: (url: string) => url.match(/(\/)(\w+-\d+)/)?.at(2)
  },
  [SupportedIntegrationProductSlugs.jiraOnPremIntegration]: {
    title: getIntegrationProductInfoFromSlug(ProductSlugs.jiraOnPremIntegration)
      .displayName,
    getIssueKeyByUrl: (url: string) => url.match(/(\/)(\w+-\d+)/)?.at(2)
  },
  [SupportedIntegrationProductSlugs.customIntegration]: {
    title: getIntegrationProductInfoFromSlug(ProductSlugs.customIntegration)
      .displayName,
    getIssueKeyByUrl: (url: string) => url.match(/(\/)(\w+-\d+)/)?.at(2)
  }
};

type IntegrationIssueLinkProps = {
  productSlug: SupportedIntegrationProductSlugs;
  issue: UniversalIssue;
};
//for the future change the tag title to the issue status
const IntegrationIssueLink: React.FC<IntegrationIssueLinkProps> = ({
  productSlug,
  issue
}) => {
  const { title, getIssueKeyByUrl } = integrationContentMap[productSlug];
  const { integrationUrl } = issue;

  const issueKey = React.useMemo(
    () => (integrationUrl ? getIssueKeyByUrl(integrationUrl) : ''),
    [integrationUrl]
  );

  return integrationUrl ? (
    <div className={styles.integrationLinkContent}>
      <h3>{title}:</h3>
      <Link
        url={integrationUrl}
        variant="button-secondary"
        className={styles.linkButton}
      >
        <IntegrationLogo
          integrationProductSlug={ProductSlugs.jiraIntegration}
        />
        {/* Out of MVP scope, for future add issue title displaying*/}
        <span>
          {issueKey}
          {/*:[title]*/}
        </span>
        {/* Out of MVP scope, for future add status displaying*/}
        {/* <Tag>{t('To Do')}</Tag> */}
      </Link>
    </div>
  ) : null;
};

export default IntegrationIssueLink;
